
export const formatCompactCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        notation: 'compact',
        compactDisplay: 'short'
    }).format(value);
};

export const formatDetailedCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}


export const formatPercentage = (value) => {
    return `${value.toFixed(2)}%`;
};

export const formatMonth = (monthNumber) => {
    return new Date(2000, monthNumber - 1).toLocaleString('default', { month: 'short' });
};

export const formatCurrency = (value, currency = 'BRL') => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    const locale = currency === 'USD' ? 'en-US' : 'pt-BR';
    const safeValue = Number.isFinite(numValue) ? numValue : 0;

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(safeValue);
};

/**
 * Check if a value is a meaningful positive number.
 * Returns true if the value parses to a number greater than 0.
 */
export const hasValue = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
};

/**
 * Format a currency value, or return a dash if the value is zero/empty.
 */
export const formatOrDash = (value, currency) => {
    if (!hasValue(value)) return '—';
    return formatCurrency(value, currency);
};